/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsDeleteNewsResponse } from "./NewsDeleteNewsResponse";

export type NewsDeleteNewsResponseApiRespoonse = {
  data?: NewsDeleteNewsResponse;
  status?: NewsDeleteNewsResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace NewsDeleteNewsResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
